import DadLogo from "@/components/DadLogo";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-8">
          <DadLogo className="dad-logo-auth" data-testid="login-wordmark" />
        </div>
        <form onSubmit={submit} className="glass rounded-3xl p-8 space-y-4" data-testid="reset-form">
          <h1 className="font-display font-bold text-lg">Nuova password</h1>
          <input data-testid="reset-password" type="password" required minLength={8} value={password}
            onChange={(e) => setPassword(e.target.value)} className="input-dark" placeholder="Almeno 8 caratteri" />
          {error && <div data-testid="reset-error" className="text-sm text-red-400">{error}</div>}
          <button data-testid="reset-submit" type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Aggiornamento…" : "Aggiorna password"}
          </button>
          <div className="text-center">
            <Link to="/login" className="text-xs text-gray-500 hover:text-cyan-300">Torna all'accesso</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
